import { deleteCart } from "@/libs/api";
import { mapActions } from "vuex";
import { types as Cart } from "@/store/cart";
import { types as Vi } from "@/store/vi";
import { types as Home } from "@/store/home";
import { editCart } from "@/libs/api";
import { simpleDebounce,getCookie } from "@/libs/common.js";
import floatingStrip from "@/components/floatingStrip.vue";
const actions = mapActions({
  getCartList: Cart.CART_LIST,
  getPilotCityCartList: Cart.CART_LIST_PILOT_CITY,
  getGoodsDetail: Vi.GOODS_DETAIL,
});
export default {
  name: "cartList",
  components: {floatingStrip},
  data() {
    return {
      uleUrl: "",
      allCheck: false,
      prodItems: false,
      isEmpty: false,
      itemList: [],
      offList: [], // 已加架商品
      limit: false,
      storage: 100,
      popActive: 0,
      sizeActive: 0,
      subList: [],
      unionInfos: {},
      shareId: "",
      store_id: "",
      freshActType: "",
      popData: {
        listName: "",
        price: "",
        mkPrice: "",
        colors: [],
        sellNum: 12, // 接口数据缺失
        prodCount: 1, //起购数量  //接口数据缺失
        minNum: 1, // 接口数据缺失
        defItemId: "",
      },
      client_type: "wap_ylxdsq",
      hideColor: false, //是否隐藏规格项
      targetUrl: `https://h5.${this.$uleUrl()}/yxd/community`,
      isLogin: false,
      cartType:'12',
      isShowFloatStrip:false,
      adid:'',
      deliveryAreaId:''
    };
  },
  mounted() {
    let _this = this;
    this.$cookies.remove('successBack','/', '.'+ this.$uleUrl());
    console.log(this.$cookies.get('ul_adid'),'=====adid====')
    this.adid = this.$cookies.get('ul_adid') || '';
    console.log('app定位',this.getStorage("home", "home.AD_CODE"))
    if(this.$browser().ulemax){
      this.freshActType = '1'
      this.cartType = `SD_${getCookie("pilotAreaId") || ''}`
    // window.dsBridge.register("refreshList", function(s) {
    //   _this.refreshList();
    // });
    // window.dsBridge.call("registRefreshWebNotification", {
    //   JSViewWillAppearFunctionName: "refreshList",
    // });
    // _this.fetch();
    }
    this.isLogin =
      getCookie("mall_cookie") || getCookie("ul_utk")
        ? true
        : false;
    if (getCookie("mall_cookie") || getCookie("ul_utk")) {
      this.client_type =
        getCookie("ul_sch") || getCookie("client_type");
      if (this.$browser().ylxdsq || this.$browser().yzgxd || this.$browser().ulemax) {
        this.deliveryAreaId = getCookie("deliveryAreaId") || '';
        window.dsBridge &&
          window.dsBridge.call("setNativeTitle", {
            title: "购物车",
          });
      }
      this.uleUrl = this.$uleUrl();
      if (this.$browser().ylxdsq || this.$browser().ulemax) {
        //app环境
        this.appGetPioltFlag();
      } else if (
        this.$route.query.freshActType ||
        getCookie("ispioltCity")
      ) {
        this.freshActType =
          this.$route.query.freshActType || getCookie("ispioltCity");
          if(this.freshActType == 1){
            this.itemList= [{ itemInfos: [] }]
          }else{
            this.itemList= []
          }
          this.fetch();
      } else {
        if(this.freshActType == 1){
          this.itemList= [{ itemInfos: [] }]
        }else{
          this.itemList= []
        }
        this.fetch();
      }
    } else {
      this.targetUrl = `${this.targetUrl}${this.$route.fullPath}`;
      this.$dialog
        .confirm({
          title: "提示",
          message: "请先登录",
        })
        .then(() => {
          window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(
              this.targetUrl
          )}`;
          // if (this.$browser().miniprogram) {
          //   window.wx.miniProgram.navigateTo({
          //     url:
          //       "/pages/authorize?target=" +
          //       encodeURIComponent(this.targetUrl) +
          //       "&type=webView", //跳转非tabBar页面(目前就指非首页index)。参数以路径后面拼接即可
          //   });
          // } else {
          //   window.location.href = `//m.${this.$uleUrl()}/muser/user/login?target=${encodeURIComponent(
          //     this.targetUrl
          //   )}`;
          // }
        })
        .catch(() => {});
    }
    console.log('freshActType===2222=',this.freshActType)
  },
  computed: {
    // 计算选中的个数
    selectNumber() {
      let num = 0;
      this.itemList.forEach((element) => {
        element.itemInfos.forEach((item) => {
          if (item.checked) {
            num++;
          }
        });
      });
      return num;
    },
    // 计算选中的价格
    selectPrice() {
      let price = 0;
      this.itemList.forEach((element) => {
        element.itemInfos.forEach((item) => {
          if (item.checked) {
            price += item.unitPrice * item.itemCount;
          }
        });
      });
      return price;
    },
  },
  methods: {
    ...actions,
    appGetPioltFlag() {
      dsBridge.call("getPilotStatus", {
        ios_action: "getPilotStatusResult",
        android_action: "getPilotStatusResult",
      });
      dsBridge.register("getPilotStatusResult", (s) => {
        if (typeof s == "string") {
          s = JSON.parse(s);
        }
        if (s) {
          this.freshActType = "1";
          document.cookie = `ispioltCity=1;domain=.${this.$uleUrl()};path=/;expires=3600`;
          this.itemList= [{ itemInfos: [] }]
        }else{
          this.itemList = []
        }
        this.fetch();
      });
    },
    // 获取购物车列表
    fetch() {
      let params = {};
      // 试点城市
      if (this.freshActType == "1") {
        params.deliveryAreaId = getCookie("deliveryAreaId") || '';
        if(this.$browser().ulemax){
          params.cartType = `SD_${getCookie("pilotAreaId") || ''}`
        }else{
          params.cartType = "12";
        }
        console.log('购物车请求参数',params)
        this.getPilotCityCartList(params).then((res) => {
          console.log('购物车接口数据res====',res)
          if(this.$browser().ulemax){
            if (res.cartInfo && res.cartInfo.storeInfos.length > 0) {
              this.itemList = res.cartInfo.storeInfos;
              if (this.itemList.length > 0) {
                this.isEmpty = false;
                this.itemList.forEach((item,index) => {
                  this.$set(item, 'checked', false);
                  item.itemInfos.forEach((ele,num) => {
                    if (ele.prdStatus == 2 || ele.storageNum == 0) {
                      this.offList.push(ele);
                      //  item.itemInfos.splice(num,1)
                    }
                    this.$set(ele, 'checked', false);
                    if (ele.limitWay == 0 || ele.limitWay > 7) {
                      //不限购
                      ele.minNum = ele.limitNum || 1;
                      ele.maxNum = ele.storageNum;
                    } else if (ele.limitWay == 1) {
                      // 每个订单最大数量限制,最小1个最多限制数量个
                      ele.minNum = 1;
                      ele.maxNum = ele.limitNum;
                    } else if (ele.limitWay == 4) {
                      // 起售
                      ele.minNum = ele.limitNum || 1;
                      ele.maxNum = ele.storageNum;
                    } else if (ele.limitWay == 6) {
                      //每日限购
                      ele.minNum = ele.limitNum || 1;
                      ele.maxNum = ele.saleLimitNum;
                    }
                    //购买数量大于库存时，数量改为库存(团购存在此问题)
                    if (+ele.itemCount > +ele.storageNum) {
                      ele.itemCount = +ele.storageNum;
                    }
                  });
                });
              } else {
                this.isEmpty = true;
              }
              this.selectAll();
            } else {
              this.isEmpty = true;
            }
          }else{
          if (
            res.cartInfo &&
            res.cartInfo.itemInfos &&
            res.cartInfo.itemInfos.length > 0
          ) {
            res.cartInfo.itemInfos.forEach((ele) => {
              // 已下架商品或已售罄
              if (ele.prdStatus == 2 || ele.storageNum == 0) {
                this.offList.push(ele);
              } else {
                this.itemList[0].itemInfos.push(ele);
              }
            });
            // this.itemList = [{
            // 	itemInfos : res.cartInfo.itemInfos
            // }]
            if (this.itemList[0].itemInfos.length > 0) {
              this.allCheck = true; // 默认全选
            } else {
              this.allCheck = false; // 默认全选
            }
            this.isEmpty = false;
            this.itemList.forEach((item) => {
              this.$set(item, "checked", true);
              item.itemInfos.forEach((ele) => {
                this.$set(ele, "checked", true);
                if (ele.limitWay == 0 || ele.limitWay > 7) {
                  //不限购
                  ele.minNum = ele.limitNum || 1;
                  ele.maxNum = ele.storageNum;
                } else if (ele.limitWay == 1) {
                  // 每个订单最大数量限制,最小1个最多限制数量个
                  ele.minNum = 1;
                  ele.maxNum = ele.limitNum;
                } else if (ele.limitWay == 4) {
                  // 起售
                  ele.minNum = ele.limitNum || 1;
                  ele.maxNum = ele.storageNum;
                } else if (ele.limitWay == 6) {
                  //每日限购
                  ele.minNum = ele.limitNum || 1;
                  ele.maxNum = ele.saleLimitNum;
                }
                //购买数量大于库存时，数量改为库存(团购存在此问题)
                if (+ele.itemCount > +ele.storageNum) {
                  ele.itemCount = +ele.storageNum;
                }
              });
            });
            this.selectAll();
          } else {
            this.isEmpty = true;
          }
          }
          
        });
      } else {
        this.isShowFloatStrip = true;
        this.getCartList(params).then((res) => {
          // this.totalPrice = res.cartInfo.totalPrice;
          this.itemList = res.cartInfo.storeInfos;
          console.log('itemList',this.itemList)
          if (this.itemList.length > 0) {
            this.isEmpty = false;
            this.itemList.forEach((item) => {
              this.$set(item, "checked", false);
              item.itemInfos.forEach((ele) => {
                this.$set(ele, "checked", false);
                if (ele.limitWay == 0 || ele.limitWay > 7) {
                  //不限购
                  ele.minNum = ele.limitNum || 1;
                  ele.maxNum = ele.storageNum;
                } else if (ele.limitWay == 1) {
                  // 每个订单最大数量限制,最小1个最多限制数量个
                  ele.minNum = 1;
                  ele.maxNum = ele.limitNum;
                } else if (ele.limitWay == 4) {
                  // 起售
                  ele.minNum = ele.limitNum || 1;
                  ele.maxNum = ele.storageNum;
                } else if (ele.limitWay == 6) {
                  //每日限购
                  ele.minNum = ele.limitNum || 1;
                  ele.maxNum = ele.saleLimitNum;
                }
                //购买数量大于库存时，数量改为库存(团购存在此问题)
                if (+ele.itemCount > +ele.storageNum) {
                  ele.itemCount = +ele.storageNum;
                }
              });
            });
          } else {
            this.isEmpty = true;
          }
        });
      }
    },
    // refreshList() {
    //   window.location.reload(true);
    // },
    // 底部全选
    selectAll() {
      console.log(this.itemList);
      this.itemList.forEach((element) => {
        if (this.allCheck) {
          element.itemInfos.forEach((item) => {
            item.checked = true;
          });
        } else {
          element.itemInfos.forEach((item) => {
            item.checked = false;
          });
        }
      });
    },
    // 商品单选
    itemSingle(item) {
      // console.log(item)
      // 判断商家下的商品是否全选
      if (this.isCheckAll(item.itemInfos)) {
        item.checked = true;
      } else {
        item.checked = false;
      }
      // 判断全部商品是否全选
      if (this.isCheckAll(this.itemList)) {
        this.allCheck = true;
      } else {
        this.allCheck = false;
      }
    },
    // 店家区域全选
    businessSelectAll(item, checked) {
      // console.log(item, checked);
      item.itemInfos.forEach((element) => {
        if (checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      });
    },
    // 提交
    submit() {
      this.subList = [];
      this.unionInfos = {};
      let listArry = [];
      let ylyx_commodity_sku_code_list=[];
      this.itemList.forEach((item) => {
        item.itemInfos.forEach((ele) => {
          if (ele.checked) {
            this.subList.push(
              ele.itemId +
                ":" +
                ele.listId +
                ":" +
                ele.itemCount +
                ":" +
                ele.price
            );
            if (ele.uid && ele.uref) {
              this.unionInfos[ele.itemId] = {uid:ele.uid,uref:ele.uref}
            }            
            listArry.push(ele);
            ylyx_commodity_sku_code_list.push(ele.listId);
          }
        });
      });
      this.store_id =
        listArry[0].yxdId || this.getStorage("user", "user.STORE_ID");
      this.subList = this.subList.toString();
      this.unionInfos = JSON.stringify(this.unionInfos);
      if (this.unionInfos == '{}') {
        this.unionInfos = "";
      }
      console.log("subList==", this.subList);
      if(this.$route.query.isJumpNew){
        console.log('isJumpNew')
        let cartType = `SD_${getCookie("pilotAreaId") || ''}`;
        let url = `https://fresh-api.${this.uleUrl}/order/order/orderConfirm?ul_sch=${this.client_type}&shareId=${this.shareId}&store_id=${this.store_id}&itemInfo=${this.subList}&listingType=104&freshActType=1&cartType=${cartType}&unionInfos=${this.unionInfos}`;
        console.log('app提交链接',url)
        console.log('z====',`ulemax://ule.com/router/webview&&url::${url}##title::下单##needTitle::true`)
        window.location.href = `ulemax://ule.com/router/webview&&url::${url}##title::下单##needTitle::true`
      }else{
        console.log('老方法')
        setTimeout(() => {
          if(!this.$browser().yzgxd && !this.$browser().ylxd){
            console.log('this.$route.fullPath===',this.$route.fullPath)
            let url = this.$route.fullPath;
            let successBack = encodeURIComponent(url);
            this.$cookies.set('successBack', successBack, 14 * 24 * 3600, '/', '.'+ this.$uleUrl());
          }
          this.$refs.orderForm.submit();
        }, 300);
      }
      //神策埋点
      let price=this.ylyx_commodity_current_price || this.goodsDetail || '';
      let amount=Number(this.prodCount) * Number(price);
      window.uleStatUtil && window.uleStatUtil.sendSensorTrack('ylyx_SettleClick', {
        ylyx_operation_type: '立即购买',
        ylyx_commodity_sku_code_list: ylyx_commodity_sku_code_list,
        ylyx_commodity_total_amount: this.selectPrice.toFixed(2)
      });
    },
    // vi跳转
    toViPage(listId){
      if(this.$browser().ulemax){
        window.dsBridge.call("generalAction", {"type":"3","router_action":`prd&&listId::${listId}`})
      }else{
        this.toNext(`/item/itemPage/${listId}?from=cartList`)
      }
    },
    // 判断是否全选
    isCheckAll(list) {
      let num = 0;
      list.forEach((item) => {
        if (item.checked === false) {
          num++;
        }
      });
      console.log();
      if (num > 0) {
        return false;
      } else {
        return true;
      }
    },
    // 删除正常商品
    deleteItem(index, item, ele, num) {
      console.log(num);
      console.log(item);
      console.log(this.itemList)
      let params = {
        listId: ele.listId,
        itemId: ele.itemId,
        itemType: ele.itemType,
        yxdId: item.storeId,
        userId: getCookie("usrOnlyid") || this.getStorage("user", "user.STORE_ID") || '',
      };
      if (this.freshActType == 1) {
        if(this.$browser().ulemax){
          params.cartType = `SD_${getCookie("pilotAreaId") || ''}`
          params.deliveryAreaId = getCookie("deliveryAreaId") || '';
        }else{
          params.cartType = "12";
        }
        console.log('删除params',params)
        deleteCart(params, "jsonCallback").then((res) => {
          if (res.returnCode === "0000") {
            // this.fetch();
            item.itemInfos.splice(index, 1);
            if (item.itemInfos.length === 0) {
              this.itemList[0].itemInfos.splice(num, 1);
            } else {
              // 获取当前的应付价格和数量
              item.storeTotalPrice = item.storeTotalPrice - ele.price;
              item.itemCount = item.itemCount - ele.itemCount;
            }
            if (this.itemList[0].itemInfos.length == 0) {
              this.allCheck = false;
              this.isEmpty = true;
            }
            this.$toast("删除成功");
          }
        });
      }else{
        deleteCart(params, "jsonCallback").then((res) => {
          if (res.returnCode === "0000") {
            // this.fetch();
            item.itemInfos.splice(index, 1);
            if (item.itemInfos.length === 0) {
              this.itemList[num].itemInfos.splice(num, 1);
            } else {
              // 获取当前的应付价格和数量
              item.storeTotalPrice = item.storeTotalPrice - ele.price;
              item.itemCount = item.itemCount - ele.itemCount;
            }
            if (this.itemList[0].itemInfos.length == 0) {
              this.allCheck = false;
              this.isEmpty = true;
            }
            this.$toast("删除成功");
          }
        });
      }
      
    },
    // 删除失效商品
    delteLostItem(index, ele) {
      let params = {
        listId: ele.listId,
        itemId: ele.itemId,
        itemType: ele.itemType,
        yxdId: "",
        userId: getCookie("usrOnlyid") || this.getStorage("user", "user.STORE_ID") || '',
      };
      if (this.freshActType == 1) {
        if(this.$browser().ulemax){
          params.cartType = `SD_${getCookie("pilotAreaId") || ''}`
          params.deliveryAreaId = getCookie("deliveryAreaId") || '';
        }else{
          params.cartType = "12";
        }
      }
      console.log("params===", params);
      deleteCart(params, "jsonCallback").then((res) => {
        if (res.returnCode === "0000") {
          this.offList.splice(index, 1);
          this.$toast("删除成功");
        }
      });
    },
    // 获取商品规格
    getDetail(listId, itemCount, itemId, imgUrl) {
      this.prodItems = true;
      this.getGoodsDetail(listId).then((res) => {
        this.popData = Object.assign(this.popData, res);
        // 图片处理
        // if (~this.popData.imgUrl.indexOf("http://")) {
        // 	this.popData.imgUrl = this.popData.imgUrl.replace("http://", "https://");
        // 	console.log(this.popData.imgUrl);
        // }
        this.popData.imgUrl = imgUrl;
        this.storage = this.popData.colors[0].items[0].itemStorage;
        if (this.popData.limitWay == 0 || this.popData.limitWay > 7) {
          //不限购
          this.popData.prodCount = 1;
          this.minNum = this.popData.limitNum;
        } else if (this.popData.limitWay == 4) {
          // 起售
          this.minNum = this.popData.limitNum;
        } else if (this.goodsDetail.limitWay == 6) {
          this.limit = true;
        }
        this.popData.colors.map((item, index) => {
          if (item.colorName == "不适用") {
            this.hideColor = true;
          }
          item.items.map((sItem, sindex) => {
            if (sItem.itemId == itemId) {
              this.popActive = index;
              this.sizeActive = sindex;
            }
          });
        });
        this.popData.prodCount = itemCount;
        this.popData.defItemId = itemId;
      });
    },
    // 切换颜色
    changColor(index, itemId, e) {
      if (e.srcElement.className == "selected") {
        return;
      } else {
        this.popActive = index;
      }
      if (this.sizeActive >= this.popData.colors[index]["items"].length) {
        this.sizeActive = this.popData.colors[index]["items"].length - 1;
        this.popData.defItemId = this.popData.colors[index]["items"][
          this.sizeActive
        ].itemId;
      }
      this.popData.defItemId = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemId;
      this.storage = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemStorage;
      //this.maxPrice、this.price 如果有一品多价也在此处处理
      this.popData.sharePrice = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemSalPrice;
      this.popData.marketPrice = this.popData.colors[index]["items"][
        this.sizeActive
      ].itemMarketPrice;
    },
    // 切换规格
    changSize(index, e) {
      if (e.srcElement.className == "selected") {
        return;
      } else {
        this.sizeActive = index;
        this.popData.defItemId = e.target.getAttribute("itemId");
        this.storage = e.target.getAttribute("storage");
        //this.maxPrice、this.price 如果有一品多价也在此处处理
        this.popData.sharePrice = this.popData.colors[this.popActive]["items"][
          index
        ].itemSalPrice;
        this.popData.marketPrice = this.popData.colors[this.popActive]["items"][
          index
        ].itemMarketPrice;
        if (this.limit) {
          // 商品有限购
          if (Number(this.popData.limitNum) > Number(this.storage)) {
            //限购数量超出库存时取最小
            this.popData.limitNum = this.storage;
          } else {
            // this.limitNum = limitNum
          }
        } else {
          this.storage = e.target.getAttribute("storage");
          if (Number(this.popData.minNum) > Number(this.storage)) {
            // 最少购买数大于库存 ,团购商品存在这个问题
            this.$toast("商品已售罄");
            this.prodCount = this.storage;
          }
        }
      }
      if (Number(this.popData.prodCount) > Number(this.storage)) {
        this.popData.prodCount = this.storage;
      }
    },
    // 确认修改
    popEdit() {
      let params = {
        itemId: this.popData.defItemId,
        itemCount: this.popData.prodCount,
        yxdId: this.popData.storeId,
        listId: this.popData.listId,
        userId: getCookie("usrOnlyid") || this.getStorage("user", "user.STORE_ID") || ''
      };
      if (this.freshActType == "1"){
        if(this.$browser().ulemax){
          params.cartType = `SD_${getCookie("pilotAreaId") || ''}`
          params.deliveryAreaId = getCookie("deliveryAreaId") || '';
        }else{
          params.cartType = "12";
        }
      }
      editCart(params, "jsonCallback").then((res) => {
        if (res.returnCode === "0000") {
          this.$toast("修改成功");
          this.fetch();
          this.prodItems = false;
        } else {
          this.$toast(res.returnMessage);
          this.fetch();
          this.prodItems = false;
        }
      });
    },
    //购物车列表数量修改
    stepChange(value, item, num, index) {
      let params = {
        itemId: item.itemId,
        itemCount: item.itemCount,
        yxdId: item.storeId,
        listId: item.listId,
        userId: getCookie("usrOnlyid") || this.getStorage("user", "user.STORE_ID") || '',
      };
      if (this.freshActType == "1"){
        if(this.$browser().ulemax){
          params.cartType = `SD_${getCookie("pilotAreaId") || ''}`
          params.deliveryAreaId = getCookie("deliveryAreaId") || '';
        }else{
          params.cartType = "12";
        }
      } 
      editCart(params, "jsonCallback").then((res) => {
        if (res.returnCode === "0000") {
          // this.$toast("修改成功");
          // this.fetch();
          // this.prodItems = false;
          //数量修改成功计算当前要显示的数量与价格
          this.computeNum();
        } else if (res.returnCode === "0011") {
          //超出限购
          this.$toast(res.returnMessage);
          // this.$router.go(0);
          // this.itemList=[];
          // this.fetch();
        } else {
          this.$toast(res.returnMessage);
        }
      });
    },
    //列表上加减数量时计算数量与价格
    computeNum() {
      this.itemList.forEach((item) => {
        let itemCount = 0,
          storeTotalPrice = 0;
        item.itemInfos.forEach((ind) => {
          itemCount = +ind.itemCount + itemCount;
          storeTotalPrice = +ind.price * +ind.itemCount + storeTotalPrice;
        });
        this.$set(item, "itemCount", itemCount);
        this.$set(item, "storeTotalPrice", storeTotalPrice);
      });
    },
    // 页面跳转
    // toNext(path) {
    // 	let arr = Object.keys(this.$route.query).length;
    // 	if (arr === 0) {
    // 		this.$router.push(path);
    // 	} else {
    // 		this.$router.push({
    // 			path,
    // 			query: this.$route.query,
    // 		});
    // 	}
    // 	// if (this.$route.query.length !== "object") {
    // 	// 	console.log(111);
    // 	// }
    // 	// if (/ylxdsq/.test(navigator.userAgent)) {
    // 	// if (this.$browser().ylxdsq) {
    // 	//     if (navigator.userAgent.indexOf('Android') > -1) {
    // 	//         location.href = 'ulemobile://ulePopView'
    // 	//     } else {
    // 	//         location.href = 'objc:ulemobile://ulePopView'
    // 	//     }
    // 	// } else {
    // 	// this.$router.push("/");
    // 	// }
    // },
  },
};
